import React, { useState, useEffect } from "react";
import { TextArea, Dropdown, Input,Header } from "@fluentui/react-northstar";
import translate from '../../i18n/translate';
import CallCenterName from './CallCenterName';
import { useIntl } from 'react-intl';
const CheckVariable = (props) => {
    const [OnMatchedRedirect, setOnMatchedRedirect] = useState(null);
    const [OnUnMatchedRedirect, setOnUnMatchedRedirect] = useState();
    const inputItems = ["Queue", "Transfer to user", "Disconnect", "Routing", "Transfer to phone"]
    const intl = useIntl();
    const onChangeMatchedType = (value) => {
        switch (value) {
            case "queue":
                setOnMatchedRedirect(
                    <div>
                        <label>{translate("queue-name")}</label>
                        <CallCenterName
                            scope={props.scope}
                            from="regexp"
                            searchQueue
                            itemName="OnMatchedRegexpQueue"
                            getData={props.getData}
                            routingName={props.routingName}
                            displayName={props.data.onMatched !== undefined ? (props.data.onMatched?.queueDisplayName) : ''}
                        />
                    </div>

                )
                break;
            case "transfer to user":
                setOnMatchedRedirect(
                    <div>
                        <label>User name</label>
                        <CallCenterName
                            itemName="OnMatched transfer to user"
                            getData={props.getData}
                            searchactifProfils
                            routingName={props.routingName}
                            displayName={props.data.onMatched !== undefined ? (props.data.onMatched?.userDisplayName) : ''}
                        />
                    </div>
                )
                break;
            case "disconnect":

                props.getData(null, "OnMatchedDisconnect", null, props.routingName)
                setOnMatchedRedirect(null)
                break;
            case "routing":
                let routingListName = Object.keys(props.routingList);
                for (var i = 0; i < routingListName.length; i++) {
                    if (routingListName[i] === "0") {
                        routingListName[i] = 'Start'
                    }
                }
                setOnMatchedRedirect(
                    <div>
                        <label>Routing name</label>
                        <Dropdown
                            className="StaticDropDown"
                            items={routingListName}
                            onChange={(e, data) => {
                                props.getData(data.value, "OnMatchedRouting", null, props.routingName)
                            }}
                            defaultValue={props.data.onMatched !== undefined ? (props.data.onMatched.routingName === "0" ? "Start" : props.data.onMatched.routingName) : ''}
                        />
                    </div>

                )
                break;
            case "transfer to phone":
                setOnMatchedRedirect(
                    <div className="regexp-transfer-to-phone-input">
                        <label>Phone number</label>
                        <Input
                            onChange={(e, data) => {
                                props.getData(data.value, "OnMatched transfer to phone", null, props.routingName)
                            }}
                            defaultValue={props.data.onMatched !== undefined ? (props.data.onMatched?.targetId) : ''}
                        />
                    </div>
                )
                break;
            default:
                if (props.data.onMatched.targetType === "user") {
                    setOnMatchedRedirect(
                        <div>
                            <label>User name</label>
                            <CallCenterName
                                itemName="OnMatched transfer to user"
                                getData={props.getData}
                                searchactifProfils
                                routingName={props.routingName}
                                displayName={props.data.onMatched !== undefined ? (props.data.onMatched?.userDisplayName) : ''}
                            />
                        </div>
                    )
                } else if (props.data.onMatched.targetType === "phone") {
                    setOnMatchedRedirect(
                        <div className="regexp-transfer-to-phone-input">
                            <label>Phone number</label>
                            <Input
                                onChange={(e, data) => {
                                    props.getData(data.value, "OnMatched transfer to phone", null, props.routingName)
                                }}
                                defaultValue={props.data.onMatched !== undefined ? (props.data.onMatched?.targetId) : ''}
                            />
                        </div>
                    )
                }
                break;
        }
    }
    const onChangeUnMatchedType = (value) => {
        switch (value) {
            case "queue":
                setOnUnMatchedRedirect(
                    <div>
                        <label>Queue name</label>
                        <CallCenterName
                            scope={props.scope}
                            from="regexp"
                            searchQueue
                            itemName="OnUnMatchedRegexpQueue"
                            getData={props.getData}
                            routingName={props.routingName}
                            displayName={props.data.onUnMatched !== undefined && props.data.onUnMatched.queueDisplayName !== undefined ? (props.data.onUnMatched.queueDisplayName) : ''}
                        />
                    </div>

                )
                break;
            case "transfer to user":
                setOnUnMatchedRedirect(
                    <div>
                        <label>User name</label>
                        <CallCenterName
                            itemName="OnUnMatched transfer to user"
                            getData={props.getData}
                            searchactifProfils
                            routingName={props.routingName}
                            displayName={props.data.onUnMatched !== undefined && props.data.onUnMatched.userDisplayName !== undefined ? (props.data.onUnMatched.userDisplayName) : ''}
                        />
                    </div>

                )
                break;
            case "disconnect":
                props.getData(null, "OnUnMatchedDisconnect", null, props.routingName)
                setOnUnMatchedRedirect()
                break;
            case "routing":
                let routingListName = Object.keys(props.routingList);

                for (var i = 0; i < routingListName.length; i++) {
                    if (routingListName[i] === "0") {
                        routingListName[i] = 'Start'
                    }
                }
                setOnUnMatchedRedirect(
                    <div>
                        <label>Routing name</label>
                        <Dropdown
                            className="StaticDropDown"
                            items={routingListName}
                            onChange={(e, data) => {
                                props.getData(data.value, "OnUnMatchedRouting", null, props.routingName)
                            }}
                            defaultValue={props.data.onUnMatched !== undefined ? (props.data.onUnMatched.routingName === "0" ? "Start" : props.data.onUnMatched.routingName) : null}
                        />
                    </div>

                )
                break;
            case "transfer to phone":
                setOnUnMatchedRedirect(
                    <div className="regexp-transfer-to-phone-input">
                        <label>Phone number</label>
                        <Input
                            onChange={(e, data) => {
                                props.getData(data.value, "OnUnMatched transfer to phone", null, props.routingName)
                            }}
                            defaultValue={props.data.onUnMatched !== undefined && props.data.onUnMatched.targetId !== undefined ? (props.data.onUnMatched.targetId) : ''}
                        />
                    </div>
                )
                break;
            default:
                if (props.data.onUnMatched.targetType === "user") {
                    setOnUnMatchedRedirect(
                        <div>
                            <label>User name</label>
                            <CallCenterName
                                itemName="OnUnMatched transfer to user"
                                getData={props.getData}
                                searchactifProfils
                                routingName={props.routingName}
                                displayName={props.data.onUnMatched !== undefined && props.data.onUnMatched.userDisplayName !== undefined ? (props.data.onUnMatched.userDisplayName) : ''}
                            />
                        </div>

                    )
                } else if (props.data.onUnMatched.targetType === "phone") {
                    setOnUnMatchedRedirect(
                        <div className="regexp-transfer-to-phone-input">
                            <label>Phone number</label>
                            <Input
                                onChange={(e, data) => {
                                    props.getData(data.value, "OnUnMatched transfer to phone", null, props.routingName)
                                }}
                                defaultValue={props.data.onUnMatched !== undefined && props.data.onUnMatched.targetId !== undefined ? (props.data.onUnMatched.targetId) : ''}
                            />
                        </div>
                    )
                }
                break;
        }
    }
    useEffect(() => {
        if (props.data.onMatched !== undefined) {
            onChangeMatchedType(props.data.onMatched.type)
        }
    }, []);
    useEffect(() => {
        if (props.data.onUnMatched !== undefined) {
            onChangeUnMatchedType(props.data.onUnMatched.type)
        }
    }, []);
    return (
        <div >
            <Header style={{marginLeft: "50px", paddingTop:'20px'}} as="h5" content={intl.formatMessage({ id: "FORMULA" })} />
            <div style={{ display: 'flex ' }}>
                <TextArea
                    style={{ width: "355px", marginLeft: "50px", marginTop: "10px" }}
                    onChange={(e, { value }) => props.setFormulaInRouting(value,props.routingName)}
                    defaultValue={props.data.formula ? props.data.formula : ""}
                    resize="both"
                />

            </div>

            <div className="row" style={{ justifyContent: 'space-around', marginTop: '10px' }}>
                <div className="col-12" style={{ marginLeft: '50px' }}>
                    <label style={{ fontWeight: '700' }}>{translate('if-matched')}</label>
                    <div >
                        <div style={{ marginBottom: '10px' }}>
                            <Dropdown
                                items={inputItems}
                                checkable
                                getA11ySelectionMessage={{
                                    onAdd: item => `${item} has been selected.`,
                                }}
                                defaultValue={
                                    props.data.onMatched !== undefined && props.data.onMatched.type === "transfer" ?
                                        props.data.onMatched.targetType === "user" ?
                                            "Transfer to user"
                                            :
                                            "Transfer to phone"
                                        :
                                        props.data.onMatched !== undefined ?
                                            (props.data.onMatched.type.charAt(0).toUpperCase() + props.data.onMatched.type.slice(1))
                                            :
                                            null
                                }
                                onChange={(e, data) => {
                                    let value = data.searchQuery.toLowerCase();
                                    props.setOnMatched(value, props.routingName);
                                    onChangeMatchedType(value);
                                }}
                            />
                        </div>
                        {OnMatchedRedirect}
                    </div>
                </div>
                <div className="col-12" style={{ marginLeft: '50px', marginTop: '10px' }}>
                    <label style={{ fontWeight: '700' }}>{translate('if-not-matched')}</label>
                    <div >
                        <div style={{ marginBottom: '10px' }}>
                            <Dropdown
                                items={inputItems}
                                checkable
                                getA11ySelectionMessage={{
                                    onAdd: item => `${item} has been selected.`,
                                }}
                                defaultValue={
                                    props.data.onUnMatched !== undefined && props.data.onUnMatched.type === "transfer" ?
                                        props.data.onUnMatched.targetType === "user" ?
                                            "Transfer to user"
                                            :
                                            "Transfer to phone"
                                        :
                                        props.data.onUnMatched !== undefined ?
                                            (props.data.onUnMatched.type.charAt(0).toUpperCase() + props.data.onUnMatched.type.slice(1))
                                            :
                                            null
                                }
                                onChange={(e, data) => {
                                    let value = data.searchQuery.toLowerCase();
                                    props.setOnUnMatched(value, props.routingName);
                                    onChangeUnMatchedType(value)
                                }}
                            />
                        </div>
                        {OnUnMatchedRedirect}
                    </div>
                </div>

            </div>
        </div>

    )
}
export default CheckVariable;